import { _reminderTypeUtilsData } from "./reminderTypeUtilsData";
import { ReminderDto } from "@/api";

export type ReminderType = ReminderDto["reminderType"];

export interface ReminderTypeHelper {
  label: string;
}

const reminderTypesData: {
  [type in Exclude<
    ReminderType,
    "unknown"
  >]: (typeof _reminderTypeUtilsData)[keyof typeof _reminderTypeUtilsData];
} = {
  analisi: _reminderTypeUtilsData.Analisi,
  bonifica: _reminderTypeUtilsData.Bonifica,
  filtro: _reminderTypeUtilsData.Filtro,
  manutenzione: _reminderTypeUtilsData.Manutenzione,
} as const;

export interface ReminderTypeOption {
  value: ReminderType;
  label: string;
}

export function getReminderTypes(language?: string): ReminderTypeOption[] {
  const lang = (language || "it") as "it" | "de" | "en";
  return Object.entries(reminderTypesData).map(([value, data]) => ({
    value: value as ReminderType,
    label: data.label[lang] || data.label.it,
  }));
}

export function getReminderTypeHelper(
  type: ReminderType,
  language?: string,
): ReminderTypeHelper | null {
  // if (type === "unknown") {
  //   return null;
  // }
  const data = reminderTypesData[type as Exclude<ReminderType, "unknown">];
  if (!data) {
    console.error("[ReminderTypeHelper] Unknown type: " + type);
    return null;
  }

  const lang = (language || "it") as "it" | "de" | "en";
  const label = data.label[lang] || data.label.it;

  return {
    label,
  };
}
